/**
 * #1090: sayfalar tembel yüklendiği için, yeni sürüm yayınlandıktan sonra eski sekmede gezinen kullanıcı artık var
 * olmayan bir sayfa dosyasını ister ("Failed to fetch dynamically imported module"). Kullanıcı "Bir hata oluştu"
 * ekranına düşmesin diye GERÇEK gezinmenin kendi yükleme hatasında sayfa bir kez yenilenir (yeni sürümün dosyalarıyla açılır).
 * Önden yükleme (menüde üzerine gelme, açılış adresi) bu işlevi çağırmaz: orada hata yutulur, sayfa yenilenmez.
 *
 * Döngü koruması: son yenilemeden 60 sn geçmediyse (dosya gerçekten eksikse) tekrar yenilenmez ve `false` döner;
 * çağıran hatayı normal yoldan yükseltir. Çevrimdışıyken ya da depolama kapalıyken de yenilenmez.
 */
const STORAGE_KEY = 'sensei:chunk-reload-at'
const MIN_GAP_MS = 60_000

export function reloadForMissingChunk(
  reload: () => void = () => window.location.reload(),
  now: () => number = Date.now,
): boolean {
  // Bağlantı kopukken yenilemek kullanıcıyı tarayıcının "internet yok" sayfasına düşürür.
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return false
  try {
    const last = Number(window.sessionStorage.getItem(STORAGE_KEY) ?? 0)
    if (now() - last < MIN_GAP_MS) return false
    window.sessionStorage.setItem(STORAGE_KEY, String(now()))
  } catch {
    // depolama kapalıysa (gizli pencere vb.) yenileme döngüsü riski: hiç yenileme
    return false
  }
  reload()
  return true
}
